import axios from "axios";
import endpoints from "./endpoints";
import { getHeaders } from "../utils/main";

export const fetchMegasigListApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.megasigTestResultFetch,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const fetchMegasigByIdApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.megasigTestResultFetchById,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};
